<template>
  <div class="container">
    <div class="con_wrap">
      <div class="con_title">
        <img class="con_title_icon" src="../../assets/images/evaluate/success.png" >
        <div class="con_title_t">
          提交成功！
        </div>
      </div>
      <div class="con_tips">已成功提交，请耐心等待反馈</div>
      <!-- <p class="sqText" @click="goToGetConfirm">授权获取{{title?'投诉建议':'物业报修'}}评价通知</p> -->
      <div class="con_btn_wrap">
        <div class="con_btn2" @click="back">返回</div>
        <div class="con_btn" @click="details">{{title?title:"查看我的报修"}}</div>
      </div>

      <template v-if="templateIds" >
        <!-- @click="goToGetConfirm" -->
        <!-- <p class="sqText" >授权活动提醒</p> -->
        <div class="subscribeBox" >
          <wx-open-subscribe :template="templateIds"  id="subscribe-btn">
            <script type="text/wxtag-template" slot="style">
                <style>
                    .subscribe-btn {
                        margin-left: 16px;
                        padding-left: 10px;
                        padding-right: 10px;
                        line-height: 34px;
                        flex-direction: row;
                    }
                    .subscribe-img{
                      margin-top: 0px;
    
                      height: 25px;
                      width: 25px;
                    }
                    .subscribe-text{
                      color:#1296db;
                      font-size: 18px;
                      padding-right: 3px;
                    }
                    .subscribe-text1{
                      font-size: 18px;
                      color:#999999;
                    }
                </style>
            </script>
            <script type="text/wxtag-template">
                <div class="subscribe-btn" style="display:flex;align-items:center;justify-content:center;">
                  <img class='subscribe-img' src="data:image/png;base64,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"/>
                  <span class='subscribe-text'>点击此处</span>
                  <span class='subscribe-text1'>订阅服务评价通知</span>
                  
                </div>
            </script>
          </wx-open-subscribe>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getShareInfo,getWxTemplates } from "../../utils/api";
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk'
export default {
  name:"success",
  data () {
    return {
      title:"",
      ShareInfo:"",
      appid:'',
      templateId:'',
      templateIds:"",
    }
  },
  created () {
    this.title =  this.$route.query.title
    this.getWxTemplatesAction()
    this.getShareInfo();
  },
  methods: {
    back(){
      window.history.back(-1);
    },

    getWxTemplatesAction(){
      let params = {
          orderType: this.title?4:3   //活动 3物业报修 4投诉建议
        }
        getWxTemplates(params).then(res=>{
          if(res.res.code === 10000){
            var list = res.body.wxMsgTemplateList
            var list1 =[]
            for(var i=0;i<list.length;i++){
              list1.push(list[i].templateId)
            }
            this.templateIds = list1.join(',')

            console.log('this.templateId ===  ' + this.templateIds)
          }
        })
    },

    getShareInfo(){
      var url =  window.location.href.split('#')[0]
        let params = {
          url:url
        }
        if(this.$route.query.cityId){
          params.cityId = this.$route.query.cityId
        }else if(this.common.cityId)  {
          params.cityId = this.common.cityId
        }else{
          params.marketId = this.common.marketInfo.id || ''
        }
        console.log('in getShareInfo   '+ JSON.stringify(params) );
        var that = this;
        getShareInfo(params).then(res=>{
          if(res.res.code === 10000){
            this.ShareInfo =res.body;
            wx.config({
                  debug: false,
                  appId: this.ShareInfo.appid, // 必填，公众号的唯一标识
                  timestamp: this.ShareInfo.timestamp, // 必填，生成签名的时间戳，精确到秒
                  nonceStr: this.ShareInfo.nonceStr, // 必填，生成签名的随机串
                  signature: this.ShareInfo.signature, // 必填，签名
                  jsApiList: ['onMenuShareAppMessage'],
                  openTagList: ['wx-open-subscribe']
            })
            wx.error(function(res){
                  // util.showToast("错误信息== error   " + res.errMsg,6000);
                // 暂时解决不了 比较慢的iOS手机微信版本 获取的URL问题 所以config失败 使用当前url 再config 一次
                console.log('in error  '+ JSON.stringify(res) );
                var errMsg =  res.errMsg
                 if(errMsg.indexOf('config') > -1 ){
                  that.errorBackconfig();
                 }
            });

            wx.ready(()=>{
                console.log("in wx.ready")
            })
           
          }
        })
   },

    //config 失败后用当前url重新config
    errorBackconfig(){
       var url =  window.location.href.split('#')[0]
       let params = {
          url:url
        }
        if(this.$route.query.cityId){
          params.cityId = this.$route.query.cityId
        }else if(this.common.cityId)  {
          params.cityId = this.common.cityId
        }else{
          params.marketId = this.common.marketInfo.id || ''
        }
        console.log('in errorBackconfig   '+ JSON.stringify(params) );
    
        getShareInfo(params).then(res=>{
          var configMap={
              debug: false,
              appId: res.body.appid , // 必填，公众号的唯一标识
              timestamp:res.body.timestamp  , // 必填，生成签名的时间戳，精确到秒
              nonceStr: res.body.nonceStr, // 必填，生成签名的随机串
              signature: res.body.signature, // 必填，签名
              jsApiList: ['onMenuShareAppMessage'],
              openTagList: ['wx-open-subscribe']
           }
            wx.config(configMap)
            wx.error(function(res){
                  // util.showToast("错误信息== error   " + res.errMsg,6000);
                  console.log('in error  '+ JSON.stringify(res) );
            });
            wx.ready(()=>{
              console.log("in errorBackconfig wx.ready")
            })
        })

    },



    details(){
      let id = this.$route.query.id
      if(this.title=='查看投诉建议'){
        this.$router.push(`/repairComplaintDetails?id=${id}`);
      }else{
        this.$router.push(`/repairOrderDetails?id=${id}`);
      }

    },
    goToGetConfirm(){
       var url='https://mp.weixin.qq.com/mp/subscribemsg?action=get_confirm&appid=' 
       var appid =   'wx4991c2b9ad32827e'  // this.appid
       var templateId ='snE2Vq9qZapLVsp9aravBAIGVwEY2uaVXgaYjZXH1to'    //this.templateId
       var scene=this.title=='查看投诉建议'?14:15
      // 'https://rsttest.vanke.com'
       var redirectUrl =serversRootUrl//+ 'activitySuccess?isVerify='+this.activityDetails.isVerify+'&marketId='+this.activityDetails.marketId
       redirectUrl =encodeURIComponent(redirectUrl)
       var reserved = this.common.marketInfo.id
       //encodeURIComponent('test')
    
       url =url+appid +'&scene='+scene +'&template_id='+templateId+'&redirect_url='+redirectUrl + '&reserved='+reserved+'#wechat_redirect'
       console.log('url ' +url)

       window.location.href = url

    },
  },
  computed: {
    ...mapState({
      userId: state => state.common.userId,
      common: state => state.common
    })
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.con_wrap{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.con_title{
  margin-bottom: 28px;
  margin-top: 200px;
  height:66px;
  display: flex;
  align-items: center;
  .con_title_icon{
    width: 44px;
    height: 44px;
    margin:12px 14px 10px;
  }
  .con_title_t{
    font-size:48px;
    font-family:PingFangSC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:66px;

  }
}
.sqText{
  .fontSize(14px);
  color:#F58D07 ;
  width: 694px;
  display: flex;
  margin-left: 32px;
  margin-bottom: 20px;
}
.subscribeBox{
  margin-top: 40px;
  width: 750px;
  height: 100px;
  display: flex;
}

.con_tips{
  height:40px;
  font-size:28px;
  font-family:PingFangSC;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:40px;
  margin-bottom: 80px;
  text-align: center;
}
.con_btn_wrap{
  position: fixed;
  bottom: 0px;
  width: 100%;
  display: flex;
  padding: 10px 34px;
  box-sizing: border-box;
}
.con_btn,.con_btn2{
  flex: 1;
  height:76px;
  margin: 0 10px;
  background:rgba(23,64,218,1);
  border:1px solid rgba(23,64,218,1);
  border-radius:4px;
  text-align: center;
  line-height: 76px;
  font-size:32px;
  font-weight:400;
  color:rgba(255,255,255,1);
  box-sizing: border-box;
}
.con_btn2{
  background:rgba(243,245,253,1);
  border:1px solid rgba(150,170,240,1);
  color: #1740DA
}
</style>
